import workInterior from "@/assets/work-interior.jpg";
import workSiding from "@/assets/work-siding.jpg";
import workExterior from "@/assets/work-exterior.jpg";
import { Reveal } from "./Reveal";

const tiles = [
  {
    src: workExterior,
    alt: "Freshly painted modern Texas home exterior at dusk",
    label: "Exterior Painting",
  },
  {
    src: workInterior,
    alt: "Painter cutting in white trim against a sage green wall",
    label: "Interior Trim",
  },
  {
    src: workSiding,
    alt: "Craftsman replacing exterior wood siding at golden hour",
    label: "Siding & Wood",
  },
];

export function Gallery() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-24">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-accent">
            Recent Work
          </p>
          <h2 className="mt-3 font-display text-4xl text-primary md:text-5xl">
            Craftsmanship you can see.
          </h2>
        </div>
        <p className="max-w-sm text-muted-foreground">
          Every project gets the same daily-on-site attention — from cutting in trim to
          replacing weathered siding.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {tiles.map((t, i) => (
          <Reveal
            key={t.label}
            delay={i * 0.08}
            className="group relative aspect-[4/5] overflow-hidden rounded-2xl bg-muted"
          >
            <img
              src={t.src}
              alt={t.alt}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/85 via-primary/20 to-transparent opacity-90 transition-opacity group-hover:opacity-100" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <span className="inline-block rounded-full bg-accent px-3 py-1 text-xs font-semibold uppercase tracking-wider text-accent-foreground">
                {t.label}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
